import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import {
  CountryService,
  IdentityService,
  TravelService,
} from '../../../api/services';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  CountryItem,
  TravelCategory,
  TravelItemMinimal,
  UserItem,
  UserItemMinimal,
} from '../../../api/models';
import { Title } from '@angular/platform-browser';
import {
  startOfToday,
  subDays,
  isWithinInterval,
  isFirstDayOfMonth,
  getMonth,
  startOfMonth,
  lastDayOfMonth,
} from 'date-fns';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  of,
  switchMap,
} from 'rxjs';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { IdentityControllerGetAll$Params } from '../../../api/fn/identity/identity-controller-get-all';
import { enumUserRole } from '../../../shared/utils/enum-user-role';
import { correctDate } from '../../../shared/utils/utils';
import { IdentityControllerGetAllTourLeaders$Params } from '../../../api/fn/identity/identity-controller-get-all-tour-leaders';

@Component({
  selector: 'app-travels-list',
  templateUrl: './travels-list.component.html',
  styleUrl: './travels-list.component.scss',
})
export class TravelsListComponent {
  country_iso?: string;
  country?: CountryItem;
  loading = false;
  loading_page = false;
  travels: TravelItemMinimal[] = [];
  limit = 9;
  skip = 0;
  totalRecords = 0;
  types: TravelCategory[] = [];
  today = new Date();
  autocompleteLeaders$ = new BehaviorSubject<string>('');
  suggestedLeaders: UserItem[] = [];
  enumUserRole = enumUserRole;
  showMoreText = false;
  content =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

  frmSearch: FormGroup = new FormGroup({
    categories: new FormControl<number[] | undefined>(undefined),
    month: new FormControl<Date | undefined>(undefined),
    leader: new FormControl<number | undefined>(undefined),
    flight: new FormControl<boolean>(false),
  });

  constructor(
    private countryService: CountryService,
    private ar: ActivatedRoute,
    private title: Title,
    private travelService: TravelService,
    private identityService: IdentityService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.ar.params.subscribe((v) => {
      this.getTravelTypes();
      this.getCountryInfo();
      this.getTravels();
    });

    // this.ar.queryParams.subscribe((v: Params) => {
    //   if(v){
    //     if(v['type']){
    //       this.frmSearch.get('categories')?.setValue(v['type'].map( (x: any) => Number(x) ));
    //     }
    //     if(v['month']){
    //       this.frmSearch.get('month')?.setValue(new Date(v['month']));
    //     }
    //     this.getTravels();
    //   }
    // })

    this.autocompleteLeaders$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((query) => {
          if (query) {
            let params: IdentityControllerGetAllTourLeaders$Params = {
              limit: 1000,
              skip: 0,
              query,
            };
            return this.identityService.identityControllerGetAllTourLeaders(
              params,
            );
          } else {
            return of({
              data: { list: [] },
            });
          }
        }),
      )
      .subscribe({
        next: (res) => {
          this.suggestedLeaders = res.data.list;
          if (this.suggestedLeaders.length === 1) {
            this.frmSearch.get('leader')?.setValue(this.suggestedLeaders[0]);
          }
        },
      });
  }

  filterLeaders(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteLeaders$.next(query);
  }

  submitSearch() {
    //const country_obj = this.frmSearch.get('destinations')?.value;
    const categories = this.frmSearch.get('categories')?.value;
    const month = this.frmSearch.get('month')?.value
      ? correctDate(this.frmSearch.get('month')?.value).toISOString()
      : undefined;
    const leader = this.frmSearch.get('leader')?.value;
    const flight = this.frmSearch.get('flight')?.value;
    if (categories || leader || month || flight) {
      this.router.navigate(
        ['/viaggi-di-gruppo', this.country_iso, this.country!.name],
        {
          queryParams: {
            type: categories,
            month: month,
            leader: leader?.id,
            flight: flight ? 1 : undefined,
          },
        },
      );
    } else {
      this.router.navigate(
        ['/viaggi-di-gruppo', this.country_iso, this.country!.name],
        { queryParams: {} },
      );
    }
    this.getTravels();
  }

  getTravelTypes() {
    this.travelService.travelControllerGetCategories().subscribe({
      next: (res) => {
        this.types = res.data.list;
      },
    });
  }

  getCountryInfo() {
    this.loading = true;
    this.ar.params.subscribe((p: Params) => {
      if (p) {
        this.country_iso = p['iso'];
        this.countryService
          .countryControllerGetOne({ iso: this.country_iso! })
          .subscribe({
            next: (res) => {
              this.loading = false;
              this.country = res.data;
              this.title.setTitle(
                'SocialTravels - Lista viaggi - ' + this.country.name,
              );
            },
          });
      }
    });
  }

  getTravels() {
    const firstOfMonth = this.frmSearch.get('month')?.value
      ? correctDate(
          startOfMonth(new Date(this.frmSearch.get('month')?.value)),
        ).toISOString()
      : undefined;
    const lastOfMonth = this.frmSearch.get('month')?.value
      ? correctDate(
          lastDayOfMonth(new Date(this.frmSearch.get('month')?.value)),
        ).toISOString()
      : undefined;
    const flight = this.frmSearch.get('flight')?.value;
    const leader = this.frmSearch.get('leader')?.value
      ? this.frmSearch.get('leader')?.value
      : undefined;
    let leader_id = leader?.id;
    this.loading_page = true;
    this.travelService
      .travelControllerGetAll({
        limit: this.limit,
        skip: this.skip,
        countries: [this.country_iso!]!,
        categories: this.frmSearch.get('categories')?.value,
        from_date: firstOfMonth,
        to_date: lastOfMonth,
        with_flights: flight ? true : undefined,
        tour_leaders: leader_id ? leader_id : undefined,
        sort_by: 'from_date',
      })
      // .subscribe({
      //   next: (res) => {
      //     if (this.skip > 0) {
      //       this.travels = [...this.travels, ...res.data.list];
      //     } else {
      //       this.travels = res.data.list;
      //     }
      //     this.totalRecords = res.data.count;
      //     this.loading_page = false;
      //   },
      // });
      .subscribe({
        next: (res) => {
          const sorted = [...res.data.list].sort(
            (a, b) =>
              new Date(a.from_date).getTime() - new Date(b.from_date).getTime(),
          );

          if (this.skip > 0) {
            this.travels = [...this.travels, ...sorted];
          } else {
            this.travels = sorted;
          }

          this.totalRecords = res.data.count;
          this.loading_page = false;
        },
      });
  }
  resetFilters() {
    this.frmSearch.reset({
      categories: undefined,
      month: undefined,
      leader: undefined,
      flight: undefined,
    });
    this.skip = 0;
    this.travels = [];
    this.getTravels();
  }

  showMore() {
    this.skip += this.limit;
    this.getTravels();
  }

  getLeadersNameToDisplay(u: UserItemMinimal) {
    return u.name + ' ' + u.last_name;
  }

  showMoreContent() {
    this.showMoreText = !this.showMoreText;
  }
}
